import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCookieFirstPolicy, LazyCookieFirstTable } from '#components'
const lazyGlobalComponents = [
  ["CookieFirstPolicy", LazyCookieFirstPolicy],
["CookieFirstTable", LazyCookieFirstTable],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
